module.exports = __webpack_public_path__ + "media/images/undraw/reserve/push_notifications-c25552b3168e86349c5f1675cb7d1542.png";